import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddVehicleRequest } from '../models/request/vehicle/AddVehicleRequest';
import { GetVehicleListPagingAndFilterRequest } from '../models/request/vehicle/GetVehicleListPagingAndFilterRequest';

export class CommonService {
    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async uploadFile(image: File) {
        try {
            var inputObj = {
                image: image
            }

            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - UploadFile', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Common/UploadFile', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}